<div class="bp-modal mod-lg">
  <bp-modal-header [title]="'deposit_instructions' | translate">
    <a left (click)="onClickBack()" (keydown.enter)="onClickBack()" [tabIndex]="0">{{ "back" | translate }}</a>
    <a right (click)="close()" (keydown.enter)="close()" [tabIndex]="0">{{ "close" | translate }}</a>
  </bp-modal-header>
  <div class="bp-modal-body">
    @if (transaction) {
      <div class="content-container">
        <sepa-qr-new [wallet]="fiatWallet" [amount]="amount" [provider]="provider" [sendEmail]="true">
        </sepa-qr-new>
      </div>
    }
  </div>
</div>
